export var METHOD_TYPES;
(function (METHOD_TYPES) {
  /**
   * 代码形式的数据源方法
   */
  METHOD_TYPES["code"] = "code";
  METHOD_TYPES["form"] = "form";
})(METHOD_TYPES || (METHOD_TYPES = {}));
export var FORM_METHOD_TYPES;
(function (FORM_METHOD_TYPES) {
  FORM_METHOD_TYPES["init"] = "init";
  FORM_METHOD_TYPES["request"] = "request";
})(FORM_METHOD_TYPES || (FORM_METHOD_TYPES = {}));
//# sourceMappingURL=consts.js.map
